import type { Account } from "@/Types";

export const exampleAccount: Account = {
  name: "Chelsea Hagon",
  email: "chelseahagon@example.com",
  avatarStyle: "jdenticon",
  imageUrl:
    "https://images.unsplash.com/photo-1573496358961-3c82861ab8f4?ixid=MnwyNjcwMzh8MHwxfGFsbHx8fHx8fHx8fDE2MzQwNTU4MjU&ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
};
